import { Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { PortalShell } from '@/shared/ui/PortalShell'

/**
 * Sahifa MikroTik orqali emas ochilgan — `mac`/`nasid` yo'q
 * (`shared/lib/portalParams.ts`). Bu "Qayta urinish" bilan tuzatib
 * bo'lmaydigan holat: muammo shu SO'ROVDA, backendda emas. Yagona chora —
 * Wi-Fi'ga qaytadan ulanish (MikroTik yana to'g'ri parametrlar bilan
 * yo'naltiradi).
 */
export function ConfigErrorPage() {
  const { t } = useTranslation()
  return (
    <PortalShell>
      <Result status="warning" title={t('error.title')} subTitle={t('error.configMissing')} />
    </PortalShell>
  )
}
